import {
  AutoComplete,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  message,
} from "antd";
import React, {useContext, useEffect, useState} from "react";
import dayjs from "dayjs";
import {FIELD_TYPE, FORMAT_TIME, LOAI_PHIEU_VTYT} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {medicalSuppliesService, catalogService} from "api";

import moment from "moment";
import InputCode from "components/common/Code/Code";
import {
  isValuableString,
  jsonParse,
  randomId,
  toArray,
  toNumber,
} from "helper/common";

import {Rule} from "antd/es/form";
import {columns as suppliesDetailColumns} from "../config";
import {
  getListVTYTAPI,
  getStoreVTYTSearchKeyAPI,
} from "redux/reducer/medicalSupplies";
import Notification from "components/common/notification/notification";
import {validateMaxMin} from "helper/validate";
type EditableRowProps = {
  index: number;
};
const {INPUT, SELECT, NUMBER, DATE, AUTO_COMPLETE, COMBO_BOX, CURRENCY, CODE} =
  FIELD_TYPE;
export type EditableCellProps = {
  title: React.ReactNode;
  editable?: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  selected: boolean;
  options: any;
  name: string;
  index: number;
  type: FIELD_TYPE;
  disabled?: boolean;
  value?: any;
  onChange?: (e) => void;

  onFocus?: () => void;
  onPressEnter?: (e) => void;
  addonAfter?: any;
  initRules?: Rule[];
  hidden?: boolean;
  autoFocus?: boolean;
  form?: any;
  setTongTien?: any;
};

export const EditableRow: React.FC<EditableRowProps> = ({index, ...props}) => {
  return (
    <>
      <tr {...props} />
    </>
  );
};

export const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  selected,
  options,
  name,
  index,
  type,
  onChange,
  onPressEnter,
  disabled,
  value,
  hidden,
  autoFocus,
  form,
  setTongTien,
  initRules,
  ...restProps
}) => {
  const khoXuatId = useAppSelector(state => state.tableAdd.khoXuatId);

  const medicalSuppliesStore = useAppSelector(
    state => state.medicalSuppliesReducer
  );
  const typePhieu = medicalSuppliesStore.typePhieu;
  const [newOptions, setNewOptions] = useState<any[]>(options);
  const dispatch = useAppDispatch();
  const [currentLo, setCurrentLo] = useState(null);
  // const [currentMedicine, setCurrentMedicine] = useState();
  const [max, setMax] = useState(null);
  const [rules, setRules] = useState<Rule[]>(initRules);
  const [currentVTYT, setCurrentVTYT] = useState<any>();
  // const [tiLeUnit, setTiLeUnit] = useState(1);
  let childNode = children;
  const setFieldValue = (dataIndex: string, value: any) => {
    form?.setFieldValue([name, index, dataIndex], value);
  };
  const getFieldValue = (dataIndex: string) => {
    return form?.getFieldValue([name, index, dataIndex]);
  };
  if (dataIndex == "ngaySanXuat") {
    console.log(disabled);
    console.log(dataIndex);
  }
  useEffect(() => {
    if (record) {
      setMaxOfCell();
      setRulesOfCell();
      // if (dataIndex == "soLo" ) {
      //   setCurrentLo(record["soLo"]);
      // }
      setTongTienVT();
    }
    if (dataIndex == "donViTinhId") {
      setListUnit();
    }
    if (dataIndex == "quyCachId") {
      setQuyCach();
    }
    if (dataIndex == "soLuong") {
      // console.log(rules);
    }
    // setListUnit();
    // setQuyCach();
    // setNhomVTYT();
    // setHangSanXuat();
    // setNuocSanXuat();
    // getDonViApKQDT();
    if (dataIndex == "nhomVTYTId") {
      setNhomVTYT();
    }
    if (dataIndex == "hangSanXuatId") {
      setHangSanXuat();
    }
    if (dataIndex == "nuocSanXuatId") {
      setNuocSanXuat();
    }
    if (dataIndex == "donViApKQDTId") {
      getDonViApKQDT();
    }

    // setListBaoChe();
    // setListDuocChinh();

    // setTongTienVT();
  }, []);
  // useEffect(() => {}, []);
  useEffect(() => {
    if (
      (dataIndex == "soLo" ||
        dataIndex == "vtytid" ||
        dataIndex == "maHang" ||
        dataIndex == "tenTheoThuongMai") &&
      currentLo &&
      khoXuatId != null &&
      (typePhieu == LOAI_PHIEU_VTYT.XUAT || typePhieu == LOAI_PHIEU_VTYT.DU_TRU)
    ) {
      // console.log(currentLo);
      setValueByLo(currentLo, khoXuatId);
    }
    // if (
    //   dataIndex == "soLo" &&
    //   currentLo &&
    //   khoNhapId != null &&
    //   typePhieu == LOAI_PHIEU_VTYT.NHAP
    // ) {
    //   setValueByLo(currentLo, khoNhapId);
    // }
  }, [currentLo]);

  useEffect(() => {
    if (currentVTYT) {
      console.log(currentVTYT);
      setFieldsValueByKey(currentVTYT, undefined);
      setFieldValue("decision", currentVTYT?.bidDecision?.decision);
      setFieldValue("bidCode", currentVTYT?.bidDecision?.bidCode);
    }
  }, [currentVTYT]);

  const setFieldsValueByKey = (data, cellName) => {
    suppliesDetailColumns.forEach(column => {
      const columnName = column.dataIndex;
      if (columnName !== cellName) {
        if (column.type === DATE) {
          setFieldValue(
            columnName as string,
            data?.[String(columnName)]
              ? moment(data?.[String(columnName)])
              : null
          );
        } else {
          setFieldValue(columnName as string, data?.[String(columnName)]);
        }
      }
    });
  };

  const setValueByLo = async (soLo, khoId) => {
    const detailLo =
      soLo && khoId != null ? await getDetailLo(soLo, khoId) : {};
    setFieldsValueByKey(detailLo, "soLo");
    setFieldValue("decision", currentVTYT?.bidDecision?.decision);
    setFieldValue("bidCode", currentVTYT?.bidDecision?.bidCode);
    setTongTienVT();
  };

  // const getListThau = async () => {
  //   const params = {
  //     vtytId: getFieldValue("vtytid"),
  //   };
  //   try {
  //     const res =
  //       (await medicalSuppliesService.getListBidDecisionByVTYTParams(params)) ||
  //       [];
  //     setNewOptions(
  //       res.map(e => ({
  //         value: e?.bidDecision?.decision,
  //         label: `${e?.bidDecision?.decision} - ${dayjs(
  //           e?.bidDecision?.createDate
  //         ).year()}`,
  //       }))
  //     );
  //   } catch (error) {}
  // };
  const getListDonViAp = async () => {
    const params = {
      vtytId: getFieldValue("vtytid"),
    };
    try {
      const res =
        (await medicalSuppliesService.getListBidDecisionByVTYTParams(params)) ||
        [];
      setNewOptions(
        res.map(e => ({
          value: e?.bidDecision?.decision,
          label: `${e?.bidDecision?.decision} - ${dayjs(
            e?.bidDecision?.createDate
          ).year()}`,
        }))
      );
    } catch (error) {}
  };
  const setListUnit = async () => {
    if (dataIndex == "donViTinhId") {
      try {
        const donViTinhId = getFieldValue("donViTinhId");

        const donViTinhOptions = jsonParse(localStorage.getItem("donVi"));
        if (typePhieu == LOAI_PHIEU_VTYT.NHAP) {
          setNewOptions(donViTinhOptions);
        } else {
          const unitFind = donViTinhOptions.find(
            item => item.id === donViTinhId
          );
          // setNewOptions(listUnit.map((e) => ({ value: e.id, label: e.name })));
          if (unitFind) {
            setNewOptions([
              {
                value: unitFind.id,
                label: unitFind.name,
              },
            ]);
          } else {
            setNewOptions(donViTinhOptions);
          }
        }
      } catch (error) {
        setNewOptions([]);
      }
    }
  };
  const setNhomVTYT = async () => {
    const suppliesGroupOptions = medicalSuppliesStore.suppliesGroupList?.map(
      supplie => ({
        key: supplie.id,
        value: supplie.id,
        label: supplie.name,
      })
    );
    setNewOptions(suppliesGroupOptions);
  };
  const setHangSanXuat = async () => {
    const manufacturerOptions = medicalSuppliesStore.manufacturerList?.map(
      manufacturer => ({
        value: manufacturer.id,
        label: manufacturer.name,
      })
    );
    setNewOptions(manufacturerOptions);
  };
  const setNuocSanXuat = async () => {
    const manufacturedCountryOptions =
      medicalSuppliesStore.manufacturedCountryList?.map(
        manufacturedCountry => ({
          value: manufacturedCountry.id,
          label: manufacturedCountry.name,
        })
      );
    setNewOptions(manufacturedCountryOptions);
  };
  const getDonViApKQDT = async () => {
    const donViApOptions = medicalSuppliesStore.donViApList?.map(donVi => ({
      key: donVi.id,
      value: donVi.id,
      label: donVi.name,
    }));
    setNewOptions(donViApOptions);
  };
  // const getListUnitByVtytId = async (id) => {
  //   try {
  //     const vTUnitConversionRes =
  //       await medicalSuppliesService.getVTUnitConversion(id);

  //     vTUnitConversionRes &&
  //       setNewOptions(
  //         vTUnitConversionRes.map((unit) => ({
  //           value: unit.donViChuyenDoi,
  //           label: unit.tenDonViChuyenDoi,
  //         }))
  //       );
  //   } catch (error) {
  //     setNewOptions([]);
  //   }
  // };
  // const setListBaoChe = async () => {
  //   if (dataIndex == "baoCheId") {
  //     const res = await getListBaoChe();
  //     const listBaoChe = res;
  //     setNewOptions(listBaoChe.map((e) => ({ value: e.id, label: e.name })));
  //   }
  // };
  // const setListDuocChinh = async () => {
  //   if (dataIndex == "duocChinhId") {
  //     const res = await getListDuocChinh();
  //     const listDuocChinh = res;
  //     setNewOptions(listDuocChinh.map((e) => ({ value: e.id, label: e.name })));
  //   }
  // };
  const setMaxOfCell = () => {
    if (dataIndex == "vat" || dataIndex == "discount") {
      setMax(100);
    }
  };
  const setRulesOfCell = () => {
    // if (dataIndex == "thuocId") {
    //   setRules([{required: true, message: "Chưa có mã thuốc"}]);
    // }
  };
  useEffect(() => {
    const setOptionsThau = () => {
      if (medicalSuppliesStore.donViApList) {
        setNewOptions(
          medicalSuppliesStore.donViApList.map(donVi => ({
            // key:donVi
            // ngayCongBo: donVi.ngayCongBo ? dayjs(donVi.ngayCongBo) : null,
          }))
        );
      }
    };
    if (dataIndex == "quyetDinhThau") {
      setOptionsThau();
    }
  }, [medicalSuppliesStore.donViApList]);
  const getDetailLo = async (soLo, khoId) => {
    try {
      // const res = await pharmacyStoreService.getDetailLo(soLo, khoId);
      const medicalSuppliesRes =
        await medicalSuppliesService.searchMedicalSupplies({
          storeId: khoId,
          limit: 500,
          //Thêm 2 params cuối theo như H.A nói
          isEmpty: false,
          sortType: "EXP_DATE",
          isSearchThau: true,
        });
      if (medicalSuppliesRes?.data?.length) {
        const supplie = medicalSuppliesRes.data.find(item => item.soLo == soLo);
        return supplie || null;
      }
      return;
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy thông tin của số lô vừa nhập");
      return null;
    }
  };

  const getListLoInStoreByParams = async () => {
    if (
      typePhieu == LOAI_PHIEU_VTYT.XUAT ||
      typePhieu == LOAI_PHIEU_VTYT.DU_TRU
    ) {
      if (khoXuatId == 0 || khoXuatId) {
        // params = { ...params, khoId: khoXuatId };
        try {
          // const res = await storeService.getListLoInStoreByParams(params);
          const res = await medicalSuppliesService.searchMedicalSupplies({
            storeId: khoXuatId,
            VTYTId: getFieldValue("vtytid"),
            VTYTName: getFieldValue("tenTheoThuongMai"),
            limit: 500,
            isEmpty: false,
            sortType: "EXP_DATE",
          });
          if (res?.data?.length == 0) {
            Notification(
              "error",
              "Không có lô vật tư nào ở kho xuất thỏa mãn các tham số đã chọn"
            );
          }
          return res.data?.filter(e =>
            isValuableString(getFieldValue("tenTheoThuongMai"))
              ? e?.tenTheoThuongMai == getFieldValue("tenTheoThuongMai")
              : true
          );
        } catch (error) {
          Notification(
            "error",
            "Không có lô vật tư nào ở kho xuất thỏa mãn các tham số đã chọn"
          );
          return [];
        }
      } else {
        message.warning("Chọn kho xuất để lấy thông tin lô trong kho");
        return [];
      }
    }
    // if (typePhieu == LOAI_PHIEU_VTYT.NHAP) {
    //   if (khoNhapId == null) {
    //     message.warning("Chọn kho nhập để lấy thông tin lô trong kho");
    //     return [];
    //   } else {
    //     // params = { ...params, khoId: khoXuatId };
    //     try {
    //       // const res = await storeService.getListLoInStoreByParams(params);
    //       const res = await medicalSuppliesService.searchMedicalSupplies({
    //         storeId: khoXuatId,
    //       });
    //       if (res.length == 0) {
    //         message.info(
    //           "Không có lô vật tư nào ở kho nhập thỏa mãn các tham số đã chọn"
    //         );
    //       }
    //       return res;
    //     } catch (error) {
    //       return [];
    //     }
    //   }
    // }
  };

  const setTongTienVT = () => {
    const soLuong = toNumber(getFieldValue("soLuong")) || 0;
    const donGia =
      typePhieu === LOAI_PHIEU_VTYT.NHAP
        ? toNumber(getFieldValue("donGiaNhap")) || 0
        : toNumber(getFieldValue("donGiaXuat")) || 0;
    const discount =
      typePhieu === LOAI_PHIEU_VTYT.XUAT
        ? toNumber(getFieldValue("discount"))
        : 0;
    const vat = toNumber(getFieldValue("vat"));
    // console.log(vat);
    let giaTriHang =
      toNumber((soLuong * donGia * (100 - discount)) / 100) *
      ((100 + vat) / 100);
    // console.log(giaTriHang);
    setFieldValue("giaTriHang", giaTriHang.toFixed(0));
    setTongTien(getTongTienDon());
  };
  const getTongTienDon = () => {
    const formTable = form.getFieldValue(name) || [];
    let tongGiaTriDon = 0;
    formTable.forEach(e => {
      tongGiaTriDon += toNumber(e?.giaTriHang);
    });
    return tongGiaTriDon;
  };
  // const handleChangeUnit = (value) => {
  //   const soLuong = getFieldValue("soLuong");
  //   if (medicalSuppliesStore.vTUnitConversionList) {
  //     const unitFind = medicalSuppliesStore.vTUnitConversionList.find(
  //       (unit) => unit.donViChuyenDoi == value
  //     );
  //     const newTiLe = unitFind?.tiLe || 1;
  //     setTiLeUnit(newTiLe);
  //     setFieldValue(
  //       "soLuongTon",
  //       Number(
  //         ((getFieldValue("soLuongTon") * tiLeUnit) / newTiLe).toFixed(1)
  //       )
  //     );
  //     setFieldValue(
  //       "donGiaNhap",
  //       (getFieldValue("donGiaNhap") * newTiLe) / tiLeUnit
  //     );
  //     setFieldValue(
  //       "donGiaXuat",
  //       (getFieldValue("donGiaXuat") * newTiLe) / tiLeUnit
  //     );

  //     if (soLuong) {
  //       setTongTienVT();
  //     }
  //   }
  // };
  const setQuyCach = async () => {
    if (dataIndex == "quyCachId") {
      const listQuyCach = jsonParse(localStorage.getItem("quyCach"));
      setNewOptions(toArray(listQuyCach));
    }
  };
  useEffect(() => {
    if (dataIndex == "maHang") {
      setListMaHang();
    }
    if (dataIndex == "vtytid") {
      setListMaVTYT();
    }
    if (dataIndex == "tenTheoThuongMai") {
      setListTenTheoThuongMai();
    }
  }, [medicalSuppliesStore.vTYTSearchKeyList]);
  const setListMaVTYT = () => {
    const listMaVTYT = medicalSuppliesStore.vTYTSearchKeyList?.map(vtyt => ({
      key: randomId(),
      value: String(vtyt.id),
      label: vtyt?.id,
    }));
    setNewOptions(listMaVTYT);
  };
  const setListMaHang = () => {
    const listMaVTYT = medicalSuppliesStore.vTYTSearchKeyList
      ?.filter(e => e?.maHang)
      .map(vtyt => ({
        key: vtyt.id,
        value: vtyt?.maHang,
        label: randomId(),
      }));
    setNewOptions(listMaVTYT);
  };
  const setListTenTheoThuongMai = () => {
    console.log(medicalSuppliesStore.vTYTSearchKeyList);
    const listTenTheoThuongMai = medicalSuppliesStore.vTYTSearchKeyList?.map(
      vtyt => ({
        value: vtyt.tenTheoThuongMai,
        label: vtyt.tenTheoThuongMai,
        key: randomId(),
      })
    );
    setNewOptions(listTenTheoThuongMai);
  };
  const getVTYTSearchKey = async (fieldName, value) => {
    const vtytData = medicalSuppliesStore.vTYTSearchKeyList;
    console.log(vtytData);
    if (vtytData?.length) {
      const vtytFind = vtytData?.find(item => item[fieldName] === value);

      if (vtytFind) {
        setCurrentLo("");
        setCurrentVTYT({
          ...vtytFind,
          vtytid: vtytFind.id,
        });
        setCurrentLoByVT(vtytFind);
      }
    }
  };
  const setCurrentLoByVT = async tenVT => {
    if (tenVT) {
      let listLo = await getListLoInStoreByParams();
      const listLoExisted = form
        .getFieldValue("listVTYTReceiptDetailDto")
        ?.map(e => e?.soLo);
      const listLoReduce = listLo?.filter(
        e => !listLoExisted?.includes(e?.soLo)
      );
      setCurrentLo(listLoReduce?.[0]?.soLo);
      setFieldValue("soLo", listLoReduce?.[0]?.soLo);
    }
  };
  if (type == INPUT) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
        rules={rules}
      >
        <Input
          disabled={disabled}
          placeholder={disabled ? "--" : "Nhập"}
          onChange={async e => {
            // if (dataIndex == "thuocId") {
            //   alert(e.target.value);
            // }
          }}
        ></Input>
      </Form.Item>
    );
  }
  if (type == DATE) {
    childNode = (
      <Form.Item name={[name, index, dataIndex]}>
        <DatePicker
          disabled={disabled}
          onChange={() => {}}
          format={FORMAT_TIME.dayFull as string}
          placeholder={disabled ? "--" : "Chọn thời điểm"}
        ></DatePicker>
      </Form.Item>
    );
  }
  if (type == NUMBER) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
        rules={rules}
      >
        <InputNumber
          disabled={disabled}
          placeholder={disabled ? "--" : "Nhập"}
          onChange={e => {
            if (
              dataIndex == "soLuong" ||
              dataIndex == "discount" ||
              dataIndex == "vat"
            ) {
              setTongTienVT();
            }
            if (dataIndex == "soLuong") {
              // setRules([
              //   ...initRules,
              //   typePhieu == LOAI_PHIEU_VTYT.XUAT
              //     ? {
              //         validator: async (_, value) => {
              //           console.log(value);
              //           await validateMaxMin(
              //             "max",
              //             toNumber(value),
              //             toNumber(getFieldValue("soLuongTon"))
              //           );
              //         },
              //         message: "Số lượng xuất quá số tồn kho",
              //       }
              //     : null,
              // ]);
            }
          }}
          max={max}
          controls={false}
          {...restProps}
        ></InputNumber>
      </Form.Item>
    );
  }
  if (type == AUTO_COMPLETE) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
        rules={rules}
      >
        <AutoComplete
          showSearch
          autoFocus={autoFocus}
          allowClear
          placeholder={disabled ? "--" : "Chọn"}
          notFoundContent={null}
          value={value}
          defaultActiveFirstOption={false}
          filterOption={(inputValue, option) =>
            option?.label
              .toString()
              .toUpperCase()
              .indexOf(inputValue.toUpperCase()) !== -1
          }
          options={newOptions}
          disabled={disabled}
          onClear={() => {}}
          onClick={async e => {
            if (dataIndex == "soLo") {
              const vtytid = getFieldValue("vtytid");
              const tenTheoThuongMai = getFieldValue("tenTheoThuongMai");
              if (vtytid === 0 || vtytid || tenTheoThuongMai) {
                // console.log(vtytid);
                const medicalSuppliesRes =
                  await medicalSuppliesService.searchMedicalSupplies({
                    storeId: khoXuatId,
                    VTYTId: vtytid,
                    VTYTName: tenTheoThuongMai,
                    limit: 500,
                    isEmpty: false,
                    isSearchThau: true,
                  });
                const listLoExisted = form
                  .getFieldValue("listVTYTReceiptDetailDto")
                  ?.map(e => e?.soLo);
                const listLoReduce = medicalSuppliesRes?.data?.filter(
                  e => !listLoExisted?.includes(e?.soLo)
                );
                setNewOptions(
                  listLoReduce?.map(e => ({
                    key: e.id,
                    value: e.soLo,
                    label: e.soLo,
                  }))
                );
              } else {
                const listLo = await getListLoInStoreByParams();
                const listLoExisted = form
                  .getFieldValue("listVTYTReceiptDetailDto")
                  ?.map(e => e?.soLo);
                const listLoReduce = listLo?.filter(
                  e => !listLoExisted?.includes(e?.soLo)
                );
                setNewOptions(
                  listLoReduce?.map(e => ({
                    key: e.id,
                    value: e.soLo,
                    label: e.soLo,
                  }))
                );
              }
              // const tenTheoThuongMai = getFieldValue("tenTheoThuongMai");

              // if (!tenTheoThuongMai) {
              //   const listLo = await getListLoInStoreByParams();
              //   setNewOptions(
              //     listLo?.map((e) => ({ value: e.soLo, label: e.soLo }))
              //   );
              // } else {
              //   setSoLoOptions("tenTheoThuongMai", tenTheoThuongMai);
              // }
            }
            if (
              dataIndex === "vtytid" ||
              dataIndex == "maHang" ||
              dataIndex == "tenTheoThuongMai"
            ) {
              // if (typePhieu == LOAI_PHIEU_VTYT.XUAT) {
              //   if (khoXuatId != null) {
              //     dispatch(
              //       getListVTYTAPI({
              //         storeId: khoXuatId,
              //       })
              //     );
              //   } else {
              //   }
              // } else {
              //   dispatch(
              //     getListVTYTAPI({
              //     })
              //   );
              // }
            }
          }}
          onChange={async e => {
            if (dataIndex == "soLo") {
              // setValueByLo(e, khoXuatId);
              setCurrentLo(e);
            }
            if (dataIndex == "vtytid") {
              getVTYTSearchKey("id", Number(e) || e); //trong API getListVTYTSearchKey: vtytid là id
              setFieldsValueByKey({}, "vtytid");
              // setCurrentLoByVT(e);
            }
            if (dataIndex == "maHang") {
              getVTYTSearchKey("maHang", e);
              setFieldsValueByKey({}, "maHang");
              // setCurrentLoByVT(e);
            }
            if (dataIndex == "tenTheoThuongMai") {
              getVTYTSearchKey("tenTheoThuongMai", e);
              setFieldsValueByKey({}, "tenTheoThuongMai");
              console.log(e);
              // setCurrentLoByVT(e);
            }
          }}
          {...restProps}
        ></AutoComplete>
      </Form.Item>
    );
  }
  if (type == COMBO_BOX) {
    childNode = (
      <Form.Item
        style={{margin: 0}}
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
      >
        <Select
          showSearch
          style={{
            width: "100%",
          }}
          filterOption={(input, option) =>
            (option?.label.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          placeholder={disabled ? "--" : "Chọn"}
          options={newOptions}
          disabled={disabled}
          allowClear={true}
          onChange={e => {
            // if (dataIndex == "donViTinhId") {
            //   handleChangeUnit(e);
            // }
            if (dataIndex == "nhomVTYTId") {
              dispatch(getStoreVTYTSearchKeyAPI({nhomVTYTId: e}));
              setFieldsValueByKey({}, "nhomVTYTId");
            }
            if (dataIndex == "hangSanXuatId") {
              dispatch(getStoreVTYTSearchKeyAPI({hangSanXuatId: e}));
              setFieldsValueByKey({}, "hangSanXuatId");
            }
            if (dataIndex == "nuocSanXuatId") {
              dispatch(getStoreVTYTSearchKeyAPI({nuocSanXuatId: e}));
              setFieldsValueByKey({}, "nuocSanXuatId");
            }
          }}
          onClick={async e => {
            if (dataIndex == "donViTinhId") {
              setListUnit();
              // // const tenThuoc = getFieldValue("tenThuoc");
              // const vtytid = getFieldValue("vtytid");
              // // let listUnit: any = null;

              // if (vtytid === 0 || vtytid) {
              //   await dispatch(getVTUnitConversionAPI(vtytid));
              //   // const res = await getListUnitByVtytId(vtytid);
              //   // listUnit = res;
              // }
              // // setNewOptions(
              // //   listUnit.map((e) => ({
              // //     value: e.name,
              // //     label: e.value,
              // //   }))
              // // );
            }
            if (dataIndex == "quyCachId") {
              setQuyCach();
            }
            if (dataIndex == "nhomVTYTId") {
              setNhomVTYT();
            }
            if (dataIndex == "hangSanXuatId") {
              setHangSanXuat();
            }
            if (dataIndex == "nuocSanXuatId") {
              setNuocSanXuat();
            }
            if (dataIndex == "donViApKQDTId") {
              getListDonViAp();
            }
            if (dataIndex == "decision") {
              // getListThau();
            }
          }}
          {...restProps}
        />
      </Form.Item>
    );
  }

  if (type == CURRENCY) {
    childNode = (
      <Form.Item
        name={[name, index, dataIndex]}
        initialValue={getFieldValue(dataIndex) ?? null}
      >
        <InputNumber
          disabled={disabled}
          defaultValue={value}
          formatter={value =>
            `${Math.round(value)?.toString()}`.replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
            )
          }
          parser={value => value!.replace(/\$\s?|(,*)/g, "")}
          onChange={e => {
            if (dataIndex == "donGiaNhap" || dataIndex == "donGiaXuat") {
              setTongTienVT();
            }
          }}
          placeholder={disabled ? "--" : "Nhập"}
          addonAfter="VNĐ"
          stringMode
          controls={false}
          min={0}
          {...restProps}
        />
      </Form.Item>
    );
  }

  // if (selected) {
  //   childNode = (
  //     <Form.Item
  //       style={{margin: 0}}
  //       name={[name, index, dataIndex]}
  //       initialValue={record[dataIndex]}
  //     >
  //       <Select
  //         disabled={disabled}
  //         allowClear
  //         showSearch
  //         placeholder="Chọn"
  //         options={dataIndex == "donviTinh" ? optionsUnit : options}
  //         onChange={e => {
  //           if (dataIndex == "thuocId") {
  //           }
  //           setInputValue({...inputValue, [dataIndex]: e});
  //           handleSave(form.getFieldsValue(), index);
  //         }}
  //       />
  //     </Form.Item>
  //   );
  // }

  return <td {...restProps}>{childNode}</td>;
};
